// "use client";

import React, { useState, useEffect, useRef, useContext } from 'react';
// import { useGlobalContext } from "../../context/context";
import Tree, { TreeNode } from 'rc-tree';
import axios from 'axios';
import { DataContext } from '../../../context/DataProvider.tsx';
// import { title } from 'process';

const T2tree = () => {
  const [tdata, setData] = useState([]);
  const treeRef = useRef();
  const { setTitleSubInfo, toggleSabt } = useContext(DataContext);

  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      try {
        // const response = axios.get(
        //   `${process.env.REACT_APP_BASE_URL}/api/data/SubjectsTree`,
        // );
        // console.log('response', response);
        // const data = response.data.data;
        // console.log('data', data);

        const result = await axios(
          `${process.env.REACT_APP_BASE_URL}/api/data/SubjectsTree?parent=0`,
        );
        setData(result.data);
        // console.log('result.data', result.data);
        // setLoading(false);
      } catch (error) {
        console.log('errorfetchDataSubjectsTree', error);
        // setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, [toggleSabt]);

  const onSelect = (selectedKeys, info) => {
    const upsertSubFun = () => {
      try {
        // console.log('info.node.key', info.node.key);

        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Subject/GetById?id=${info.node.key}`,
          {
            method: 'Get',
          },
        ).then((res) => {
          console.log('res', res);
          if (!res.ok) {
            throw new Error('کد وضعیت خطا در درخواست!' + res.status);
          }
          return res
            .json()
            .then((data) => {
              console.log('data', data);
              setTitleSubInfo({
                ID: data.id,
                Title: data.title,
                Parent_ID: data.parent_ID,
                Definition: data.definition,
                Code: data.code,
                Ordering: data.ordering,
                Type_ID: data.type_ID,
                Keywords: data.keywords,
                Old_IDs: data.old_IDs,
                MainLaw_IDs: data.mainLaw_IDs,
                Section_ID: data.section_ID,
                IsActive: data.isActive,
                isChecked: data.isChecked,
              });
            })
            .catch((error) => {
              console.log('error', error);
            });
        });
      } catch (error) {
        console.log('error', error);
      }
    };

    upsertSubFun();

    // this.selKey = info.node.props.eventKey;
    // alert(selectedKeys[0]);
    // console.log(tdata);

    let hero = document.getElementById(selectedKeys[0]);
    //e.preventDefault();  // Stop Page Reloading
    hero && hero.scrollIntoView();

    // setSubjects(selectedKeys[0]);
    // setPage(1);
  };

  return (
    <Tree
      ref={treeRef}
      className="myCls"
      defaultExpandAll
      treeData={tdata ? tdata : ''}
      onSelect={onSelect}
      height={'auto'}
    />
  );
};

export default T2tree;
